import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ExtendedTransactionListResponse, ExtendedTransactionQueryParams } from '@frontend/transaction/types';

export class MyTransactionClient extends APIClient {
    public static readonly endpoint = '/transaction-api/ext/v1';

    public static async fetchMyTransactions(queryParams?: ApiQueryParams<ExtendedTransactionQueryParams>): Promise<ExtendedTransactionListResponse> {
        return await this.apiPaginated<ExtendedTransactionListResponse, ExtendedTransactionQueryParams>(`${this.endpoint}/my-transactions`, queryParams);
    }

    public static async fetchMyTransactionsAwaitingPickUp(
        queryParams?: ApiQueryParams<ExtendedTransactionQueryParams>
    ): Promise<ExtendedTransactionListResponse> {
        return await this.apiPaginated<ExtendedTransactionListResponse, ExtendedTransactionQueryParams>(
            `${this.endpoint}/my-transactions-awaiting-pick-up`,
            queryParams
        );
    }

    public static async fetchMyTransactionsAwaitingDropOff(
        queryParams?: ApiQueryParams<ExtendedTransactionQueryParams>
    ): Promise<ExtendedTransactionListResponse> {
        return await this.apiPaginated<ExtendedTransactionListResponse, ExtendedTransactionQueryParams>(
            `${this.endpoint}/my-transactions-awaiting-drop-off`,
            queryParams
        );
    }
}
